import { Settings } from "@mui/icons-material";
import { Box, Container } from "@mui/material";
import GlobalNavigation from "../../components/GlobalNavigation";
import Header from "../../components/Header";
import Helmet from "../../components/Helmet";
import Layout, {
  LayoutStateProvider,
  SidebarSwitch,
  SideSheetTrigger,
} from "../../components/Layout";
import Loading from "../../components/Loading";
import SettingsDrawer from "../../components/SettingsDrawer";
import { useExtractionTopic } from "../../domain/crud";
import { useExtractionTopicParams } from "../../paths";
import { selectData } from "../../utils";
import { TopicEditForm } from "./components/TopicEditForm";

export function EditExtractionTopic() {
  const { extractionId, topicId } = useExtractionTopicParams();

  const extractionTopicQuery = useExtractionTopic(extractionId, topicId, {
    select: selectData,
  });

  return (
    <>
      <Helmet>
        <title>Edit Extraction Topic</title>
      </Helmet>
      <LayoutStateProvider>
        <Layout
          header={
            <Header
              title="Edit Extraction Topic"
              actions={
                <SideSheetTrigger
                  title="Settings"
                  sidebarId="settings"
                  icon={<Settings />}
                />
              }
            />
          }
          globalNavigation={<GlobalNavigation />}
          sideSheet={
            <SidebarSwitch
              config={[
                {
                  id: "settings",
                  element: <SettingsDrawer />,
                },
              ]}
            />
          }
        >
          <Box sx={{ flexGrow: 1, minWidth: 0, overflowY: "auto", py: 4 }}>
            <Container fixed>
              {extractionTopicQuery.isSuccess ? (
                <TopicEditForm extractionTopic={extractionTopicQuery.data} />
              ) : (
                <Loading type="circular" />
              )}
            </Container>
          </Box>
        </Layout>
      </LayoutStateProvider>
    </>
  );
}
